module.exports = __webpack_public_path__ + "img/firewallSetting-d.e7d2e24.svg";